import React, { useEffect, useState } from "react";
import { DropdownSelect } from "@vds/selects";

import {
  UserHeadingText,
  CustomTFFrame,
  CustomTFDropdownsFrame,
  CustomTFDaysInWeek,
  FrameForDay,
  DayOfTheWeekText,
  TimeFrameText,
} from "./stylesRoiModal";
import { Body } from "@vds/typography";
import { convertToIsoFormat } from "../../../utility/Utils";
import { CREATERULE_TEST_IDS } from "../../../../pages/BulkRule/CreateRule/createRuleConstants";

function CustomTimeFrame({ onDataChange }) {
  const [selectedDays, setSelectedDays] = useState({
    Su: false,
    Mo: false,
    Tu: false,
    We: false,
    Th: false,
    Fr: false,
    Sa: false,
  });
  const [startTime, setStartTime] = useState("12:00 AM");
  const [showText, setShowText] = useState(false);
  const [endTime, setEndTime] = useState("12:30 AM");
  const [selectedTimeZone, setSelectedTimeZone] = useState("ET");
  const [isoStartTime, setIsoStartTime] = useState("");
  const [isoEndTime, setIsoEndTime] = useState("");
  const [timeParam, setTimeParam] = useState("");
  const days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const dayEnums = {
    Su: "SUNDAY",
    Mo: "MONDAY",
    Tu: "TUESDAY",
    We: "WEDNESDAY",
    Th: "THURSDAY",
    Fr: "FRIDAY",
    Sa: "SATURDAY",
  };
  const timeZones = [{title: "Eastern Time Zone" , value:"ET"}, 
    {title: "Central Time Zone" , value:"CT"}, 
    {title: "Mountain Time Zone" ,value:"MT"}, 
    {title: "Pacific Time Zone" , value:"PT"}];

  const toggleDaySelection = (day) => {
    setSelectedDays((prev) => ({
      ...prev,
      [day]: prev[day] ? false : dayEnums[day],
    }));
  };

  const selectedDayEnum = () => {
    return Object.values(selectedDays)?.filter(Boolean);
  };

  useEffect(() => {
    const enums = selectedDayEnum();
    onDataChange({
      timeParam,
      startTime: isoStartTime,
      endTime: isoEndTime,
      selectedDays: enums,
      overNightText: showText,
      timeZone: selectedTimeZone,
    });
  }, [timeParam, isoStartTime, isoEndTime, selectedDays, showText, selectedTimeZone]);

  const timeOptions = Array.from({ length: 48 }, (_, i) => {
    const hour = Math.floor(i / 2);
    const minute = i % 2 === 0 ? "00" : "30";
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${formattedHour}:${minute} ${period}`;
  }).concat("11:59 PM");

  const timeValues = timeOptions.map((time) => {
    const [timePart, period] = time.split(" ");
    let [hour, minute] = timePart.split(":");
    hour = parseInt(hour);
    minute = parseInt(minute);

    if (period === "PM" && hour !== 12) {
      hour += 12;
    } else if (period === "AM" && hour === 12) {
      hour = 0;
    }

    return hour * 60 + minute;
  });

  useEffect(() => {
    const isoStart = convertToIsoFormat(startTime);
    const isoEnd = convertToIsoFormat(endTime, showText);

    setIsoStartTime(isoStart);
    setIsoEndTime(isoEnd);
  }, [startTime, endTime]);

  const startTimeValue = timeValues[timeOptions.indexOf(startTime)];
  const filteredEndTimeOptions = timeOptions.filter(
    (_, index) => timeValues[index] > startTimeValue
  );

    useEffect(() => {
    setShowText(filteredEndTimeOptions &&
    !filteredEndTimeOptions?.some((time) => time === endTime)) 
   }, [filteredEndTimeOptions]);
    

  useEffect(() => {
    if (startTime) {
      const nextEndTime = filteredEndTimeOptions[0];
      if (!endTime) {
        setEndTime(nextEndTime);
      }
    }
  }, [startTime]);

  


  return (
    <>
      <CustomTFFrame>
        <CustomTFDropdownsFrame>
          <DropdownSelect
            label="Time parameter"
            errorText="Select a state"
            error={false}
            disabled={false}
            readOnly={false}
            inlineLabel={false}
            width="223px"
            onChange={(e) => setTimeParam(e.target.value)}
          >
            <option value="">Active between</option>
          </DropdownSelect>
          <DropdownSelect
            label="Time"
            onChange={(e) => {
              setStartTime(e.target.value);
            }}
            value={startTime}
            errorText={!startTime ? "Select start time" : undefined}
            width="184px"
          >
            {timeOptions.map((time, index) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </DropdownSelect>
          <TimeFrameText>to</TimeFrameText>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "5px",
            }}
          >
            <DropdownSelect
              label="Time"
              onChange={(e) => setEndTime(e.target.value)}
              value={endTime}
              errorText={!endTime && startTime ? "Select end time" : undefined}
              width="184px"
            >
              {timeOptions.map((time, index) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </DropdownSelect>
            {showText && (
              <Body size="small" color="#6F7171">
                Overnight alert
              </Body>
            )}
          </div>
           <DropdownSelect
                        label="Time Zone"
                        onChange={(e) => {
                          setSelectedTimeZone(e.target.value);
                        }}
                        data-testid={CREATERULE_TEST_IDS.TIME_ZONE_DROPDOWN}
                        value={selectedTimeZone}
                        errorText={!selectedTimeZone ? "Select time zone" : undefined}
                        width="264px"
                      >
                        {timeZones.map((zone) => (
                          <option key={zone.value} value={zone.value}>
                            {zone.title}
                          </option>
                        ))}
                      </DropdownSelect>
        </CustomTFDropdownsFrame>
        <CustomTFDaysInWeek>
          {days.map((day) => (
            <FrameForDay
              key={day}
              isSelected={selectedDays[day]}
              onClick={() => toggleDaySelection(day)}
              onMouseDown={(e) => {
                e.preventDefault();
              }}
            >
              <DayOfTheWeekText>{day}</DayOfTheWeekText>
            </FrameForDay>
          ))}
        </CustomTFDaysInWeek>
      </CustomTFFrame>
    </>
  );
}

export default CustomTimeFrame;
